export const dummyarchs = [
    {
        _id: '658e626dc2ee7ad523bfed0f',
        project_id: 'xcvbcx-tN-wg88DY',
        createdAt: '2023-12-29T06:08:45.030Z',
        imageUrl: 'swdfgds',
        metadata: {
            nodes: {
                UI_1: {
                    id: 'UI_1',
                    type: 'ResizableNode',
                    position: {
                        x: 30,
                        y: 130,
                    },
                    data: {
                        clientFramework: 'react',
                        applicationFramework: 'react',
                        packageName: 'ui',
                        Id: 'UI_1',
                        label: '',
                        applicationName: 'webapp',
                        serverPort: '4200',
                        withExample: 'false',
                        applicationType: 'gateway',
                        theme: '',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                        backgroundColor: '#b2f2bb',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 30,
                        y: 130,
                    },
                    dragging: true,
                },
                Gateway_1: {
                    id: 'Gateway_1',
                    type: 'ResizableNode',
                    position: {
                        x: 210,
                        y: 130,
                    },
                    data: {
                        Id: 'Gateway_1',
                        label: '',
                        applicationName: 'gateway',
                        applicationFramework: 'java',
                        packageName: 'com.libaray.gateway',
                        serverPort: '9020',
                        applicationType: 'gateway',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                        backgroundColor: '#b2f2bb',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 210,
                        y: 130,
                    },
                    dragging: true,
                },
                Service_1: {
                    id: 'Service_1',
                    type: 'ResizableNode',
                    position: {
                        x: 430,
                        y: 130,
                    },
                    data: {
                        applicationFramework: 'spring',
                        prodDatabaseType: 'postgresql',
                        Id: 'Service_1',
                        label: '',
                        applicationName: 'backend',
                        packageName: 'com.libarary.backend',
                        serverPort: '9021',
                        applicationType: 'microservice',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                        backgroundColor: '#b2f2bb',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 430,
                        y: 130,
                    },
                    dragging: true,
                },
                Database_1: {
                    id: 'Database_1',
                    type: 'selectorNode',
                    position: {
                        x: 430,
                        y: 250,
                    },
                    data: {
                        prodDatabaseType: 'postgresql',
                        isConnected: true,
                        Id: 'Database_1',
                    },
                    style: {
                        border: '1px solid black',
                        padding: '4px 4px',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 430,
                        y: 250,
                    },
                    dragging: true,
                },
                group_1: {
                    id: 'group_1',
                    type: 'GroupNode',
                    position: {
                        x: 410,
                        y: 80,
                    },
                    data: {
                        label: 'backend service',
                        Id: 'group_1',
                        type: 'Group',
                        groupName: 'backend service',
                    },
                    style: {
                        border: '1px dashed',
                        borderRadius: '15px',
                        width: 160,
                        height: 250,
                        zIndex: -1,
                        backgroundColor: '#ffec99',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 410,
                        y: 80,
                    },
                    dragging: true,
                },
            },
            edges: {
                'UI_1-Gateway_1': {
                    id: 'UI_1-Gateway_1',
                    source: 'UI_1',
                    sourceHandle: 'source.Right',
                    target: 'Gateway_1',
                    targetHandle: 'target.Left',
                    markerEnd: {
                        color: 'black',
                        type: 'arrowclosed',
                    },
                    type: 'smoothstep',
                    data: {
                        client: 'webapp',
                        server: 'gateway',
                        type: 'synchronous',
                        framework: 'rest-api',
                    },
                    className: 'success',
                },
                'Service_1-Database_1': {
                    id: 'Service_1-Database_1',
                    source: 'Service_1',
                    sourceHandle: 'source.Bottom',
                    target: 'Database_1',
                    targetHandle: 'target.Top',
                    markerEnd: {
                        color: 'black',
                        type: 'arrowclosed',
                    },
                    type: 'smoothstep',
                    className: 'success',
                },
                'Gateway_1-Service_1': {
                    id: 'Gateway_1-Service_1',
                    source: 'Gateway_1',
                    sourceHandle: 'source.Right',
                    target: 'Service_1',
                    targetHandle: 'target.Left',
                    markerEnd: {
                        color: 'black',
                        type: 'arrowclosed',
                    },
                    type: 'smoothstep',
                    data: {
                        client: 'gateway',
                        server: 'backend',
                        type: 'synchronous',
                        framework: 'rest-api',
                    },
                    className: 'success',
                },
            },
        },
        parentId: '658d7a15099efed25b177fd3',
        updatedAt: '2023-12-29T07:03:34.833Z',
        projectName: 'xcvbcx',
        draft: {
            0: {
                clientFramework: 'react',
                applicationFramework: 'react',
                packageName: 'ui',
                Id: 'UI_1',
                label: '',
                applicationName: 'webapp',
                serverPort: '4200',
                withExample: 'false',
                applicationType: 'gateway',
                theme: '',
                authenticationType: 'no',
            },
            1: {
                Id: 'Gateway_1',
                label: '',
                applicationName: 'gateway',
                applicationFramework: 'java',
                packageName: 'com.libaray.gateway',
                serverPort: '9020',
                applicationType: 'gateway',
                authenticationType: 'no',
            },
            2: {
                applicationFramework: 'spring',
                prodDatabaseType: 'postgresql',
                Id: 'Service_1',
                label: '',
                applicationName: 'backend',
                packageName: 'com.libarary.backend',
                serverPort: '9021',
                applicationType: 'microservice',
                authenticationType: 'no',
            },
        },
    },
    {
        _id: '658e6274c2ee7ad523bfed13',
        project_id: 'xcvbcx-tv17BkZYe',
        createdAt: '2023-12-29T06:08:52.699Z',
        imageUrl: 'swdfgds',
        metadata: {
            nodes: {
                UI_1: {
                    id: 'UI_1',
                    type: 'ResizableNode',
                    position: {
                        x: 30,
                        y: 130,
                    },
                    data: {
                        clientFramework: 'react',
                        applicationFramework: 'react',
                        packageName: 'ui',
                        Id: 'UI_1',
                        label: '',
                        applicationName: 'webapp',
                        serverPort: '4200',
                        withExample: 'false',
                        applicationType: 'gateway',
                        theme: '',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                        backgroundColor: '#b2f2bb',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 30,
                        y: 130,
                    },
                    dragging: true,
                },
                Gateway_1: {
                    id: 'Gateway_1',
                    type: 'ResizableNode',
                    position: {
                        x: 210,
                        y: 130,
                    },
                    data: {
                        Id: 'Gateway_1',
                        label: '',
                        applicationName: 'gateway',
                        applicationFramework: 'java',
                        packageName: 'com.libaray.gateway',
                        serverPort: '9020',
                        applicationType: 'gateway',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                        backgroundColor: '#b2f2bb',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 210,
                        y: 130,
                    },
                    dragging: true,
                },
                Service_1: {
                    id: 'Service_1',
                    type: 'ResizableNode',
                    position: {
                        x: 430,
                        y: 130,
                    },
                    data: {
                        applicationFramework: 'spring',
                        prodDatabaseType: 'postgresql',
                        Id: 'Service_1',
                        label: '',
                        applicationName: 'backend',
                        packageName: 'com.libarary.backend',
                        serverPort: '9021',
                        applicationType: 'microservice',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                        backgroundColor: '#b2f2bb',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 430,
                        y: 130,
                    },
                    dragging: true,
                },
                Database_1: {
                    id: 'Database_1',
                    type: 'selectorNode',
                    position: {
                        x: 430,
                        y: 250,
                    },
                    data: {
                        prodDatabaseType: 'postgresql',
                        isConnected: true,
                        Id: 'Database_1',
                    },
                    style: {
                        border: '1px solid black',
                        padding: '4px 4px',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 430,
                        y: 250,
                    },
                    dragging: true,
                },
                group_1: {
                    id: 'group_1',
                    type: 'GroupNode',
                    position: {
                        x: 410,
                        y: 80,
                    },
                    data: {
                        label: 'backend service',
                        Id: 'group_1',
                        type: 'Group',
                        groupName: 'backend service',
                    },
                    style: {
                        border: '1px dashed',
                        borderRadius: '15px',
                        width: 160,
                        height: 250,
                        zIndex: -1,
                        backgroundColor: '#ffec99',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 410,
                        y: 80,
                    },
                    dragging: true,
                },
            },
            edges: {
                'UI_1-Gateway_1': {
                    id: 'UI_1-Gateway_1',
                    source: 'UI_1',
                    sourceHandle: 'source.Right',
                    target: 'Gateway_1',
                    targetHandle: 'target.Left',
                    markerEnd: {
                        color: 'black',
                        type: 'arrowclosed',
                    },
                    type: 'smoothstep',
                    data: {
                        client: 'webapp',
                        server: 'gateway',
                        type: 'synchronous',
                        framework: 'rest-api',
                    },
                    className: 'success',
                },
                'Service_1-Database_1': {
                    id: 'Service_1-Database_1',
                    source: 'Service_1',
                    sourceHandle: 'source.Bottom',
                    target: 'Database_1',
                    targetHandle: 'target.Top',
                    markerEnd: {
                        color: 'black',
                        type: 'arrowclosed',
                    },
                    type: 'smoothstep',
                    className: 'success',
                },
                'Gateway_1-Service_1': {
                    id: 'Gateway_1-Service_1',
                    source: 'Gateway_1',
                    sourceHandle: 'source.Right',
                    target: 'Service_1',
                    targetHandle: 'target.Left',
                    markerEnd: {
                        color: 'black',
                        type: 'arrowclosed',
                    },
                    type: 'smoothstep',
                    data: {
                        client: 'gateway',
                        server: 'backend',
                        type: 'synchronous',
                        framework: 'rest-api',
                    },
                    className: 'success',
                },
            },
        },
        parentId: '658d7a15099efed25b177fd3',
        updatedAt: '2023-12-29T06:08:52.699Z',
        projectName: 'xcvbcx',
    },
    {
        _id: '658e6279c2ee7ad523bfed15',
        project_id: 'xcvbcx-loz60wq1Y',
        createdAt: '2023-12-29T06:08:57.717Z',
        imageUrl: 'swdfgds',
        metadata: {
            nodes: {
                UI_1: {
                    id: 'UI_1',
                    type: 'ResizableNode',
                    position: {
                        x: 30,
                        y: 130,
                    },
                    data: {
                        clientFramework: 'react',
                        applicationFramework: 'react',
                        packageName: 'ui',
                        Id: 'UI_1',
                        label: '',
                        applicationName: 'webapp',
                        serverPort: '4200',
                        withExample: 'false',
                        applicationType: 'gateway',
                        theme: '',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                        backgroundColor: '#b2f2bb',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 30,
                        y: 130,
                    },
                    dragging: true,
                },
                Gateway_1: {
                    id: 'Gateway_1',
                    type: 'ResizableNode',
                    position: {
                        x: 210,
                        y: 130,
                    },
                    data: {
                        Id: 'Gateway_1',
                        label: '',
                        applicationName: 'gateway',
                        applicationFramework: 'java',
                        packageName: 'com.libaray.gateway',
                        serverPort: '9020',
                        applicationType: 'gateway',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                        backgroundColor: '#b2f2bb',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 210,
                        y: 130,
                    },
                    dragging: true,
                },
                Service_1: {
                    id: 'Service_1',
                    type: 'ResizableNode',
                    position: {
                        x: 430,
                        y: 130,
                    },
                    data: {
                        applicationFramework: 'spring',
                        prodDatabaseType: 'postgresql',
                        Id: 'Service_1',
                        label: '',
                        applicationName: 'backend',
                        packageName: 'com.libarary.backend',
                        serverPort: '9021',
                        applicationType: 'microservice',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                        backgroundColor: '#b2f2bb',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 430,
                        y: 130,
                    },
                    dragging: true,
                },
                Database_1: {
                    id: 'Database_1',
                    type: 'selectorNode',
                    position: {
                        x: 430,
                        y: 250,
                    },
                    data: {
                        prodDatabaseType: 'postgresql',
                        isConnected: true,
                        Id: 'Database_1',
                    },
                    style: {
                        border: '1px solid black',
                        padding: '4px 4px',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 430,
                        y: 250,
                    },
                    dragging: true,
                },
                group_1: {
                    id: 'group_1',
                    type: 'GroupNode',
                    position: {
                        x: 410,
                        y: 80,
                    },
                    data: {
                        label: 'backend service',
                        Id: 'group_1',
                        type: 'Group',
                        groupName: 'backend service',
                    },
                    style: {
                        border: '1px dashed',
                        borderRadius: '15px',
                        width: 160,
                        height: 250,
                        zIndex: -1,
                        backgroundColor: '#ffec99',
                    },
                    selected: false,
                    positionAbsolute: {
                        x: 410,
                        y: 80,
                    },
                    dragging: true,
                },
            },
            edges: {
                'UI_1-Gateway_1': {
                    id: 'UI_1-Gateway_1',
                    source: 'UI_1',
                    sourceHandle: 'source.Right',
                    target: 'Gateway_1',
                    targetHandle: 'target.Left',
                    markerEnd: {
                        color: 'black',
                        type: 'arrowclosed',
                    },
                    type: 'smoothstep',
                    data: {
                        client: 'webapp',
                        server: 'gateway',
                        type: 'synchronous',
                        framework: 'rest-api',
                    },
                    className: 'success',
                },
                'Service_1-Database_1': {
                    id: 'Service_1-Database_1',
                    source: 'Service_1',
                    sourceHandle: 'source.Bottom',
                    target: 'Database_1',
                    targetHandle: 'target.Top',
                    markerEnd: {
                        color: 'black',
                        type: 'arrowclosed',
                    },
                    type: 'smoothstep',
                    className: 'success',
                },
                'Gateway_1-Service_1': {
                    id: 'Gateway_1-Service_1',
                    source: 'Gateway_1',
                    sourceHandle: 'source.Right',
                    target: 'Service_1',
                    targetHandle: 'target.Left',
                    markerEnd: {
                        color: 'black',
                        type: 'arrowclosed',
                    },
                    type: 'smoothstep',
                    data: {
                        client: 'gateway',
                        server: 'backend',
                        type: 'synchronous',
                        framework: 'rest-api',
                    },
                    className: 'success',
                },
            },
        },
        parentId: '658d7a15099efed25b177fd3',
        updatedAt: '2023-12-29T06:08:57.717Z',
        projectName: 'xcvbcx',
        draft: {
            0: {
                clientFramework: 'react',
                applicationFramework: 'react',
                packageName: 'ui',
                Id: 'UI_1',
                label: '',
                applicationName: 'webapp',
                serverPort: '4200',
                withExample: 'false',
                applicationType: 'gateway',
                theme: '',
                authenticationType: 'no',
            },
            1: {
                Id: 'Gateway_1',
                label: '',
                applicationName: 'gateway',
                applicationFramework: 'java',
                packageName: 'com.libaray.gateway',
                serverPort: '9020',
                applicationType: 'gateway',
                authenticationType: 'no',
            },
            2: {
                applicationFramework: 'spring',
                prodDatabaseType: 'postgresql',
                Id: 'Service_1',
                label: '',
                applicationName: 'backend',
                packageName: 'com.libarary.backend',
                serverPort: '9021',
                applicationType: 'microservice',
                authenticationType: 'no',
            },
        },
    },
    {
        _id: '658e6e3cc2ee7ad523bfeff7',
        project_id: 'awdawd-RuwmnlYLZ',
        createdAt: '2023-12-29T06:59:08.117Z',
        imageUrl: 'swdfgds',
        metadata: {
            nodes: {
                UI_1: {
                    id: 'UI_1',
                    type: 'ResizableNode',
                    position: {
                        x: 640,
                        y: 130,
                    },
                    data: {
                        clientFramework: 'react',
                        applicationFramework: 'react',
                        packageName: 'ui',
                        Id: 'UI_1',
                        label: 'sefgsef',
                        applicationName: 'sefsefes',
                        serverPort: '3423',
                        withExample: 'false',
                        applicationType: 'gateway',
                        theme: '',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                    },
                    selected: false,
                },
            },
        },
        parentId: '658d7a15099efed25b177fd3',
        updatedAt: '2023-12-29T06:59:08.117Z',
        projectName: 'awdawd',
    },
    {
        _id: '658e6e84c2ee7ad523bff00c',
        project_id: 'awdawd-iqGigSsKh',
        createdAt: '2023-12-29T07:00:20.674Z',
        imageUrl: 'swdfgds',
        metadata: {
            nodes: {
                UI_1: {
                    id: 'UI_1',
                    type: 'ResizableNode',
                    position: {
                        x: 640,
                        y: 130,
                    },
                    data: {
                        clientFramework: 'react',
                        applicationFramework: 'react',
                        packageName: 'ui',
                        Id: 'UI_1',
                        label: 'sefgsef',
                        applicationName: 'sefsefes',
                        serverPort: '3423',
                        withExample: 'false',
                        applicationType: 'gateway',
                        theme: '',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                    },
                    selected: false,
                },
            },
        },
        parentId: '658d7a15099efed25b177fd3',
        updatedAt: '2023-12-29T07:00:20.674Z',
        projectName: 'awdawd',
    },
    {
        _id: '658e6e85c2ee7ad523bff00e',
        project_id: 'awdawd-JteHb9Qy2',
        createdAt: '2023-12-29T07:00:21.805Z',
        imageUrl: 'awfesrgdfe',
        metadata: {
            nodes: {
                UI_1: {
                    id: 'UI_1',
                    type: 'ResizableNode',
                    position: {
                        x: 640,
                        y: 130,
                    },
                    data: {
                        clientFramework: 'react',
                        applicationFramework: 'react',
                        packageName: 'ui',
                        Id: 'UI_1',
                        label: 'sefgsef',
                        applicationName: 'sefsefes',
                        serverPort: '3423',
                        withExample: 'false',
                        applicationType: 'gateway',
                        theme: '',
                        authenticationType: 'no',
                    },
                    style: {
                        border: '1px solid black',
                        width: '120px',
                        height: '40px',
                        borderRadius: '15px',
                    },
                    selected: false,
                },
            },
        },
        parentId: '658d7a15099efed25b177fd3',
        updatedAt: '2023-12-29T07:00:21.805Z',
        projectName: 'awdawd',
    },
];